import moment from "moment";

export const enableChristmasTheme = () => {
    const today = moment();
    const min = moment(`12-10-${today.get('year')}`, 'MM-DD-YYYY');
    const max = moment(`01-05-${today.get('year') + 1}`, 'MM-DD-YYYY');
    return today.isBetween(min, max);
}

export const enableEasterTheme = () => {
    const today = moment();
    const min = moment(`04-10-${today.get('year')}`, 'MM-DD-YYYY');
    const max = moment(`04-25-${today.get('year')}`, 'MM-DD-YYYY');
    return today.isBetween(min, max);
}